import { Box, Button, Typography } from '@material-ui/core'
import { useState } from 'react'
import API from '../../api/api'
import { askMagicLinkMutation } from '../../api/mutations/userMutations'
import ErrorMessage from '../../components/UI/ErrorMessage'
import CommonTextField from '../../components/UI/Form/CommonTextField'
import { useErrorState } from '../../hooks/useErrorState'

export default function MagicLinkGenerator() {
  const [email, setEmail] = useState('')
  const [isResponseOk, setIsResponseOk] = useState(false)
  const { error, setErrorState } = useErrorState()

  const askMagicLink = async (e) => {
    e.preventDefault()

    if (email == '') {
      return
    }

    try {
      await API.queryAPI(askMagicLinkMutation(email))

      setIsResponseOk(true)
    } catch (errorMessage) {
      setErrorState(errorMessage)
    }
  }

  return (
    <form action="" onSubmit={askMagicLink}>
      <Box mb={2}>
        <Typography variant="h4">Générer un lien d’authentification</Typography>
      </Box>
      <Box mb={2} variant="subtitle1">
        Pour vous connecter de manière simple, rapide et sécurisée, veuillez renseigner votre adresse e-mail.
        <br />
        <br />
        Vous recevrez alors un message contenant un lien d’authentification qui vous permettra d’accéder à votre compte
        en un seul clic.
      </Box>
      <CommonTextField
        type="email"
        name="email"
        onChange={(value) => setEmail(value)}
        label="Email"
        required
        disabled={isResponseOk}
      />
      {isResponseOk && (
        <Box color="green" mb={2}>
          Un e-mail vous a été envoyé avec un lien d’authentification.
        </Box>
      )}
      <ErrorMessage error={error} />
      <Button type="submit" variant="contained" color="secondary" fullWidth disabled={isResponseOk}>
        Envoyer
      </Button>
    </form>
  )
}
